import React, { useState, useEffect } from "react";
import Joyride, { EVENTS } from "react-joyride";
import "./tour.css";
import { useNavigate, useLocation } from "react-router-dom";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { useTour } from "./context";
import Navbar from "../Navbar";

export default function Tour() {
  const { state, setState } = useTour();
  const { run, stepIndex, steps } = state;

  const navigate = useNavigate();
  const location = useLocation();
  const showButton = location.pathname === "/home";

  const [minimized, setMinimized] = useState(false);

  // Botão some após 5s
  useEffect(() => {
    if (!showButton || run) return;

    let timer;
    if (!minimized) {
      timer = setTimeout(() => setMinimized(true), 5000);
    }

    return () => clearTimeout(timer);
  }, [showButton, run, minimized]);

  // Definir passos na primeira montagem
  useEffect(() => {
    setState({
      steps: [
        {
          target: ".logo-navbar",
          content: (
            <p>
              Olá! Este é um tour guiado pela plataforma. Vamos apresentar
              algumas funcionalidades do <b>LesteBoard</b> para que você possa
              aproveitá-lo ao máximo!
            </p>
          ),
          disableBeacon: true,
        },
        {
          target: ".theme",
          content:
            <p>Aqui você encontra os icones para voltar para o <b>inicio</b> e alternar entre temas <b>claro</b> e <b>escuro</b>.</p>,
          disableBeacon: true,
        },
        {
          target: ".notifications-usuario",
          content:
            <p>Aqui você encontra as <b>notificações</b> e um menu com algumas opções como <b>logout</b>.</p>,
          disableBeacon: true,
        }, 
        {
          target: ".novo-quadro",
          content:
            <p>Aqui você encontra as opções para criar<br/> <b>novos quadros</b> e <b>etiquetas</b> para o seu board.</p>,
          disableBeacon: true,
        },
        {
          target: ".lista-usuario",
          content:
            <p>Essa lista mostra os membros da <b>equipe</b>.<br/> Apenas os que fazem parte do <b>seu time</b> estarão por aqui.</p>,
          disableBeacon: true,
        },
        {
          target: ".quadros-participantes",
          content:
            <p>Aqui estão todos os quadros aos quais <b>você foi incluído</b>. Para que determinados quadros apareçam aqui, o <b>dono do quadro</b> precisa adicionar você</p>,
          // data: { previous: "/home" },
          disableBeacon: true,
        },
        {
          target: ".seus-quadros",
          content:
            <p>Aqui ficam todos os quadros que <b>você mesmo criou</b>. Outros usuários só conseguem visualizar <b>se forem permitidos</b></p>,
          // data: { next: "/board/tutorial" },
          disableBeacon: true,
        },
        {
          target: ".logo-navbar",
          content: (
            <p>
              Vamos navegar através de um <b>board</b> para explorar algumas
              funcionalidades.
              <br /> Fique tranquilo, ele sempre estará aqui para esclarecer
              dúvidas{" "}
            </p>
          ),
          data: { next: "/tutorial" },
          disableBeacon: true,
        },
        {
          target: ".titulo-board-tutorial",
          content: (
            <p>
              Chegamos agora ao <b>board tutorial</b>, esse aqui é o{" "}
              <b>Título</b> do board.
            </p>
          ),
          data: { previous: "/home" },
          disableBeacon: true,
        },
        {
          target: ".membros-busca",
          content: (
            <p>
              Aqui temos as informações sobre os <b>membros online</b>,{" "}
              <b>busca de cards</b> e um <b>filtro por tags</b> do board.
            </p>
          ),
          // data: { previous: "/home" },
          disableBeacon: true,
        },
        {
          target: ".menu-direito",
          content: (
            <p>
              Aqui se encontram várias funcionalidades para o <b>board</b> como
              : <b>permissões</b>, <b>editar informações</b> e{" "}
              <b>cards arquivados</b> do seu board.
            </p>
          ),
          // data: { previous: "/home" },
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".lista-usuario",
          content: (
            <p>
              Essas são as <b>listas</b>, onde todos os <b>cartões</b> e{" "}
              <b>notas</b> ficam disponíveis para acesso.
              <br /> Elas podem ser <b>compactadas</b> e <b>arrastadas</b> para
              melhor organização
            </p>
          ),
          // data: { previous: "/home" },
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".button-add-list",
          content: (
            <p>
              Essa opção serve para adicionar novas <b>listas</b>. Crie quantas
              desejar, o importante é sempre buscar a melhor organização do seu{" "}
              <b>board</b>
            </p>
          ),
          // data: { previous: "/home" },
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".note-padrao-tour",
          content: (
            <p>
              Esse é um exemplo de <b>nota</b>, normalmente utilizadas para
              informações de rápida visualização. Podem ser personalizadas como
              preferir.
            </p>
          ),
          // data: { previous: "/home" },
          // placement: "right",
          disableBeacon: true,
        },
        // {
        //   target: ".menu-direito",
        //   content:
        //     <p>Aqui está um </p>,
        //   // data: { previous: "/home" },
        //   placement: "right",
        //   disableBeacon: true,
        // },
        {
          target: ".card-padrao-tour",
          content: (
            <p>
              Aqui está um exemplo de <b>card</b>, eles são a essência de todo{" "}
              <b>board</b>. Informações importantes estarão sempre por aqui.{" "}
              <br />
              Vamos abrir o exemplo para conferir as funcionalidades disponíveis
            </p>
          ),
          data: { action: "openModal" },
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".titulo-card-tour",
          content: (
            <p>
              Esse é o <b>título</b> do card. <br />
              Para alterar, basta clicar sobre ele.
            </p>
          ),
          data: { closeAction: "closeModal" },
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".card-cover",
          content: (
            <p>
              Aqui é a <b>capa do card</b>, onde podemos <b>excluir</b> ou{" "}
              <b>arquivar</b> e também verificar as etiquetas aplicadas. A cor da capa pode
              ser personalizada,
            </p>
          ),
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".buttons-actions",
          content: (
            <p>
              Com essas opções você pode adicionar <b>checklists</b>,{" "}
              <b>alterar a capa</b>, <b>tags</b> e <b>copiar o card</b>.
              Clicando em <b>compartilhar</b> um link será copiado, facilitando
              o acesso ao card.
            </p>
          ),
          placement: "right",
          disableBeacon: true,
          disableScrolling: true,
        },
        {
          target: ".description-anexos",
          content: (
            <p>
              Em <b>descrição</b> você pode detalhar melhor as informações do
              card.
              <br /> Já em <b>anexos</b> é possível adicionar arquivos
              importantes para o seu time.
            </p>
          ),
          placement: "right",
          disableBeacon: true,
          disableScrolling: true,
        },
        {
          target: ".checklist-card-content",
          content: (
            <p>
              Na seção de <b>checklist</b> você pode adicionar tarefas e
              acompanhar o progresso delas. Muito útil para organizar etapas de
              um projeto, por exemplo.
            </p>
          ),
          placement: "right",
          disableBeacon: true,
        },
        {
          target: ".atividades-logs",
          content: (
            <p>
              Por fim, temos a seção de <b>atividades</b> e <b>logs</b>, onde
              você pode acompanhar tudo o que foi realizado no card, garantindo
              total transparência para o seu time.
            </p>
          ),
          data: { closeAction: "closeModal", closeBeforeNext: true },
          placement: "left",
          disableBeacon: true,
          hideBackButton: true,
          showSkipButton: false,
        },
        {
          target: ".logo-navbar",
          content: (
            <p>
              Finalizamos o tour! Agora é só explorar e aproveitar ao máximo o{" "}
              <b>LesteBoard</b>! <br />
              Lembre-se que você pode acessar esse tour a qualquer momento
              clicando no botão no fim da página.
            </p>
          ),
          data: { next: "/home" },
          disableBeacon: true,
          placement: "center", // opcional, pode centralizar para chamar atenção
          hideBackButton: true, // esconde o botão "Anterior"
          hideCloseButton: true, // esconde o "X" de fechar
          showSkipButton: false, // desativa a opção de pular
        },
      ],
    });
    console.log("cheguei aqui!");
  }, [setState]);

  const waitForTarget = (targetSelector, callback) => {
    const el = document.querySelector(targetSelector);
    if (el) {
      callback();
    } else {
      requestAnimationFrame(() => waitForTarget(targetSelector, callback));
    }
  };

  // Callback do Joyride
  const handleCallback = (data) => {
    const { action, index, type, step } = data;
    const isPrev = action === "prev";

    if (type === EVENTS.STEP_AFTER) {
      const nextRoute = isPrev ? step.data?.previous : step.data?.next;

      // Abrir modal apenas se avançar
      if (!isPrev && step.data?.action) {
        if (typeof step.data.action === "function") {
          step.data.action();
        } else if (
          typeof step.data.action === "string" &&
          state.actions[step.data.action]
        ) {
          state.actions[step.data.action]();
        }
      }

      // Fechar modal somente se voltar ou se fechar antes de avançar
      if ((isPrev || step.data?.closeBeforeNext) && step.data?.closeAction) {
        if (typeof step.data.closeAction === "function") {
          step.data.closeAction();
        } else if (
          typeof step.data.closeAction === "string" &&
          state.actions[step.data.closeAction]
        ) {
          state.actions[step.data.closeAction]();
        }
      }

      // Navegação entre rotas
      if (nextRoute && location.pathname !== nextRoute) {
        setState({ run: false });
        if (nextRoute === "/home") {
          setState({ stepIndex: 0 });
          navigate(nextRoute);
          return;
        }
        navigate(nextRoute);
        waitForTarget(steps[index + (isPrev ? -1 : 1)]?.target, () => {
          setState({ stepIndex: index + (isPrev ? -1 : 1), run: true });
        });
        return;
      }

      setState({ stepIndex: isPrev ? index - 1 : index + 1 });
    }

    if (["finished", "skipped"].includes(data.status)) {
      setState({ run: false, stepIndex: 0 });
    }
  };

  return (
    <>
      {!run && showButton && (
        <div className="parte-final">
          {!minimized ? (
            <button
              className="tour-button"
              onClick={() => {
                if (!run) setState({ run: true, stepIndex: 0 });
              }}
              title="Faça um tour pelo sistema"
            >
              Conheça o LesteBoard
            </button>
          ) : (
            <div
              className="tour-minimized"
              onMouseEnter={() => setMinimized(false)}
              title="Abrir botão do tour"
            >
              <TipsAndUpdatesIcon />
            </div>
          )}
        </div>
      )}

      <Joyride
        key={run ? "tour-running" : "tour-stopped"}
        run={run}
        steps={steps}
        stepIndex={stepIndex}
        continuous
        scrollToFirstStep
        showSkipButton
        showBackButton
        disableOverlayClose
        disableCloseOnEsc={false}
        hideCloseButton
        callback={handleCallback}
        styles={{
          options: { zIndex: 1000, primaryColor: "#009373" },
        }}
        locale={{
          back: "Anterior",
          next: "Próximo",
          skip: "Pular",
          last: "Finalizar",
        }}
      />
    </>
  );
}
